import React, { useContext, useRef, useState } from "react";
import { Link, useNavigate, useLocation  } from "react-router-dom";
import {
  AppBar,
  Box,
  Toolbar,
  Container,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Grid,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { LogoBox, PrimaryMenu, MenuButton, SubMenuBar, SubMenuContainer, SubMenuButton } from "./NavbarStyles";
import Logo from "../../Logo";
import { ThemeContext } from "../../../context/ThemeContext";
import { ArrowDropDown } from "@mui/icons-material";


const Navbar = () => {
  const { filterByCategory, setFilterByCategory } = useContext(ThemeContext);

  const navigate = useNavigate();
  const location = useLocation();

  const timeoutRef = useRef({});
  const isHoveringMenu = useRef(false);

  const pathToPage = {
    "/": "Home",
    "/about": "About Us",
    "/contact": "Contact Us",
    "/syndicate_reports": "Our Solutions",
    "/competitive_intelligence": "Our Solutions",
    "/coming_soon": "Our Solutions",
    "/articles": "Resources",
    "/press_releases": "Resources",
    "/case_studies": "Resources",
    "/news_letters": "Resources",
  };
  
  const [active, setActive] = useState(pathToPage[location.pathname] || "");
  const [mobileOpen, setMobileOpen] = useState(false);
  const [showSubMenu, setShowSubMenu] = useState(false);
  const [menuName, setMenuName] = useState('');

  //stop setTimeout
  const stopTimeout = (id) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current[id]);
      timeoutRef.current[id] = null;
    }
  };

  //open sub menu bar
  const openSubMenu = (page) => {
    setShowSubMenu(true);
    setMenuName(page);
  };

  const handleSubMenuBar = () => {
    stopTimeout(1);
    stopTimeout(2);
    stopTimeout(3);
    isHoveringMenu.current = true; // ✅ Mark that we are inside submenu
    setShowSubMenu(true);
  }

  //close sub menu bar
  const closeSubMenu = () => {
    isHoveringMenu.current = false; // ✅ Mark leaving submenu
    stopTimeout(1);
    timeoutRef.current[1] = setTimeout(() => {
      setShowSubMenu(false);
    }, 1000);
  };


  const primaryMenuItems = [
    { page: "Home", path: "/", hover: false },
    { page: "Our Solutions", path: null, hover: true },
    { page: "Industries", path: null, hover: true },
    { page: "Resources", path: null, hover: true },
    { page: "About Us", path: "/about", hover: false },
    { page: "Contact Us", path: "/contact", hover: false },
  ];

  const ourSolutions = [
    { path: "/syndicate_reports", page: "Syndicate Reports" },
    { path: "/competitive_intelligence", page: "Competitive Intelligence" },
    { path: "/coming_soon", page: "Custom Research Services" },
    { path: "/coming_soon", page: "Consulting" },
    { path: "/coming_soon", page: "Primary Market Solutions" },
    { path: "/coming_soon", page: "Market Monitoring" },
    { path: "/coming_soon", page: "Market Trend Reports" },
  ];
  
  const industriesCategory = [
    { path: "/syndicate_reports", page: "Life Sciences" },
    { path: "/syndicate_reports", page: "Consumer Goods" },
    { path: "/syndicate_reports", page: "Material and Chemicals" },
    { path: "/syndicate_reports", page: "Construction and Manufacturing" },
    { path: "/syndicate_reports", page: "Food and Beverages" },
    { path: "/syndicate_reports", page: "Energy and Power" },
    { path: "/syndicate_reports", page: "Semiconductor and Electronics" },
    { path: "/syndicate_reports", page: "Automotive and Transportation" },
    { path: "/syndicate_reports", page: "ICT & Media" },
    { path: "/syndicate_reports", page: "Aerospace and Defense" },
    { path: "/syndicate_reports", page: "BFSI" }
  ];
  
  const resources = [
    { path: "/articles", page: "Articles" },
    { path: "/press_releases", page: "Press Release" },
    { path: "/case_studies", page: "Case Study" },
    { path: "/news_letters", page: "News Letter" },
  ];

  const submenuItems = {
    "Our Solutions": ourSolutions,
    "Industries": industriesCategory,
    "Resources": resources,
  };

  const [arrowDirection, setArrowDirection] = useState({
    "Our Solutions": 0,
    "Industries": 0,
    "Resources": 0,
  });

  const [open, setOpen] = useState(null);
  
  //mobile screen menu
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleIndustryMenu = (page) => {
    setArrowDirection((prev) => ({
      ...prev,
      [page]: (prev[page] || 0) + 180,
    }));
    page = page === 360 ?  0 : page;
    setOpen((prev) => (prev === page ? null : page));
  };

  const handleDrawerMenu = (path, page) => {
    if (page !== "Our Solutions" && page !== "Industries" && page !== "Resources") {
      handleDrawerToggle();
      navigate(path);
    } else {
      handleIndustryMenu(page);
    }
  };

  const subMenuPages = menuName === 'Our Solutions' ? ourSolutions : menuName === 'Resources' ? resources : undefined;

  return (
    <AppBar position="sticky" sx={{ bgcolor: "#55d6aa" }}>
      
      {showSubMenu && (
        
        <SubMenuBar
          onMouseEnter={handleSubMenuBar}
          onMouseLeave={closeSubMenu}
        >

          {/* Our Solutions & Resources Menu */}
          {(menuName === "Our Solutions" || menuName === "Resources") && (
            <SubMenuContainer>
              {subMenuPages.map(({ path, page }) => (
                <SubMenuButton
                  variant="outlined"
                  key={page}
                  onClick={() => {
                    navigate(path);
                    setActive(menuName);
                  }}
                >
                  {page}
                </SubMenuButton>
              ))}
            </SubMenuContainer>
          )}

          {/* Industries Menu */}
          {showSubMenu && menuName === "Industries" && (
            <Grid
              container
              rowSpacing={2}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              sx={{ p: 3, width: '80%' }}
            >
              {industriesCategory.map(({path, page}) => (
                <Grid size={3} key={page}>
                  <Typography
                    onClick={() => {
                      setFilterByCategory(page);
                      setTimeout(() => navigate(path), 1000);
                      console.log("filter category", filterByCategory);
                    }}
                    sx={{
                      cursor: "pointer",
                      fontSize: "0.9rem",
                      borderBottom: "2px solid #55d6aa",
                    }}
                  >
                    {page}
                  </Typography>
                </Grid>
              ))}
            </Grid>
          )}

        </SubMenuBar>
      )}


      <Container maxWidth="xxl">
        <Toolbar
          disableGutters
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          {/* Logo and Name */}
          <Link to="/">
            <LogoBox>
              <Logo width="100%" height="100%" />
            </LogoBox>
          </Link>

          {/* Primary Menu */}
          <PrimaryMenu>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              {primaryMenuItems.map(({ page, path, hover }) => (
                <Link
                  key={page}
                  to={path || "#"}
                  onMouseEnter={
                    hover
                      ? () => {
                          openSubMenu(page);
                        }
                      : undefined
                  }
                >
                  <MenuButton
                    variant="standard"
                    active={active === page}
                    onClick={() => setActive(page)}
                  >
                    {page}
                  </MenuButton>
                </Link>
              ))}
            </Box>

            {/* <Box>
              <MenuButton2 sx={{ "&:hover": { bgcolor: "inherit"} }} >Sign In</MenuButton2>
            </Box> */}
          </PrimaryMenu>

          {/* ====================================================================================================================== */}

          {/* Mobile Screen */}
          <IconButton
            color="inherit"
            Inputpage="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ display: { md: "none" }, mr: 2 }}
          >
            <MenuIcon />
          </IconButton>

          {/* Mobile Drawer */}
          <Drawer
            anchor="right"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            sx={{ display: { md: "none" } }}
          >
            <List sx={{ bgcolor: "#242424", color: "#55d6aa", width: { xs: '60vw', sm: '40vw' }, height: "100%", overflowY: 'scroll',  }}>
              {primaryMenuItems.map(({ path, page }) => (
                <ListItem key={path} disablePadding>
                  <ListItemButton
                    onClick={() => handleDrawerMenu(path, page)}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "start",
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        // justifyContent: "left",
                        alignItems: "center",
                      }}
                    >
                      <ListItemText primary={page} />
                      {(page === "Our Solutions" || page === "Industries" || page === "Resources") && (
                        <ArrowDropDown
                          sx={{
                            transition: "transform 0.3s ease",
                            transform: `rotate(${arrowDirection[page]}deg)`,
                          }}
                        />
                      )}
                    </Box>

                    {/* Industry - Categories Mapped */}
                    {submenuItems[page] && open === page && (
                      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, ml: 1, color: "whitesmoke" }}>
                        {submenuItems[page].map(({ path, page }) => (
                          <Typography
                            key={page}
                            onClick={() => {
                              navigate(path);
                              console.log(path);
                              setFilterByCategory(page); // Optional — only if needed for all pages
                              setMobileOpen(false);
                            }}
                            sx={{ cursor: "pointer", fontSize: "0.6rem", "&:hover": { color: "#fff" } }}
                          >
                            {page}
                          </Typography>
                        ))}
                      </Box>
                    )}
                  </ListItemButton>
                </ListItem>
              ))}
              <Button sx={{ my: 2, color: "#ffdd24" }}>Sign In</Button>
            </List>
          </Drawer>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar;
